import { PickingAuditDetail } from "../../../../../../core";

const iconsOfActionsList = [
  {
    icon: 'add-jaba',
    tooltip: 'Adicionar jaba'
  },
  {
    icon: 'pre-cancel',
    tooltip: 'Pre cancelar'
  },
  {
    icon: 'confirm-audit',
    tooltip: 'Confirmar'
  },
];

export const pickingAuditDetail = {
  searchText: "",
  addText: "",
  checkbox: true,
  filter: false,
  filterDefault: "",
  disabled: false,
  iconsOfActions: iconsOfActionsList,
  classValidation: (row: any) => {
    if (row.isAudited) {
      return 'confirmed';
    }
    return '';
  },
  hasDisabledCheckBoxItem: (row: any) => {
    return row.isAudited
      || row.amountAttended === row.amountCancelled
  },
  columns: [
    {
      title: "Jaba",
      name: "containerCode",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: PickingAuditDetail) => element.containerCode,
    },
    {
      title: "Lote",
      name: "lotId",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: PickingAuditDetail) => element.lotNumber ? element.lotNumber : '-',
    },
    {
      title: "EANCode",
      name: "eanCode",
      type: "string",
      checkAll: false,
      editable: false,
      class: "left",
      value: (element: PickingAuditDetail) => element.eanCode.split(',').length ? element.eanCode.split(',')[0] : element.eanCode,
    },
    {
      title: "SKU",
      name: "skuCode",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: PickingAuditDetail) => element.skuCode,
    },
    {
      title: "Descripción",
      name: "description",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: PickingAuditDetail) => element.description,
    },
    {
      title: "Sustituto",
      name: "skuReplacement",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: PickingAuditDetail) => element.skuReplacement ? "Sí" : "No",
    },
    {
      title: "Observación",
      name: "comments",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: PickingAuditDetail) => element.comments,
    },
    {
      title: "Cantidad",
      name: "quantity",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: PickingAuditDetail) => element.amountAttended,
    }
  ],
};
